// source: advai_event/atome_id/event.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = Function('return this')()

var advai_event_atome_id_action_pb = require('../../advai_event/atome_id/action_pb.js')
goog.object.extend(proto, advai_event_atome_id_action_pb)
var advai_event_atome_id_page_pb = require('../../advai_event/atome_id/page_pb.js')
goog.object.extend(proto, advai_event_atome_id_page_pb)
goog.exportSymbol('proto.advai_event.atome_id.DeviceInfo', null, global)
goog.exportSymbol('proto.advai_event.atome_id.DeviceInfo.DeviceType', null, global)
goog.exportSymbol('proto.advai_event.atome_id.DeviceInfo.OSType', null, global)
goog.exportSymbol('proto.advai_event.atome_id.DeviceInfo.UserType', null, global)
goog.exportSymbol('proto.advai_event.atome_id.Event', null, global)
goog.exportSymbol('proto.advai_event.atome_id.EventPackage', null, global)
goog.exportSymbol('proto.advai_event.atome_id.Page', null, global)
goog.exportSymbol('proto.advai_event.atome_id.ReferrerDeviceInfo', null, global)
goog.exportSymbol('proto.advai_event.atome_id.StatusMessage', null, global)
goog.exportSymbol('proto.advai_event.atome_id.StatusMessage.Status', null, global)
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.advai_event.atome_id.StatusMessage = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.advai_event.atome_id.StatusMessage, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.advai_event.atome_id.StatusMessage.displayName = 'proto.advai_event.atome_id.StatusMessage'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.advai_event.atome_id.Page = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.advai_event.atome_id.Page, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.advai_event.atome_id.Page.displayName = 'proto.advai_event.atome_id.Page'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.advai_event.atome_id.Event = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.advai_event.atome_id.Event, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.advai_event.atome_id.Event.displayName = 'proto.advai_event.atome_id.Event'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.advai_event.atome_id.ReferrerDeviceInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.advai_event.atome_id.ReferrerDeviceInfo, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.advai_event.atome_id.ReferrerDeviceInfo.displayName = 'proto.advai_event.atome_id.ReferrerDeviceInfo'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.advai_event.atome_id.DeviceInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.advai_event.atome_id.DeviceInfo, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.advai_event.atome_id.DeviceInfo.displayName = 'proto.advai_event.atome_id.DeviceInfo'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.advai_event.atome_id.EventPackage = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.advai_event.atome_id.EventPackage.repeatedFields_, null)
}
goog.inherits(proto.advai_event.atome_id.EventPackage, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.advai_event.atome_id.EventPackage.displayName = 'proto.advai_event.atome_id.EventPackage'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.advai_event.atome_id.StatusMessage.prototype.toObject = function (opt_includeInstance) {
    return proto.advai_event.atome_id.StatusMessage.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.advai_event.atome_id.StatusMessage} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.advai_event.atome_id.StatusMessage.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        status: jspb.Message.getFieldWithDefault(msg, 1, 0),
        statusCode: jspb.Message.getFieldWithDefault(msg, 2, 0),
        message: jspb.Message.getFieldWithDefault(msg, 3, ''),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.advai_event.atome_id.StatusMessage}
 */
proto.advai_event.atome_id.StatusMessage.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.advai_event.atome_id.StatusMessage()
  return proto.advai_event.atome_id.StatusMessage.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.advai_event.atome_id.StatusMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.advai_event.atome_id.StatusMessage}
 */
proto.advai_event.atome_id.StatusMessage.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {!proto.advai_event.atome_id.StatusMessage.Status} */ (reader.readEnum())
        msg.setStatus(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setStatusCode(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setMessage(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.advai_event.atome_id.StatusMessage.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.advai_event.atome_id.StatusMessage.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.advai_event.atome_id.StatusMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.advai_event.atome_id.StatusMessage.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getStatus()
  if (f !== 0.0) {
    writer.writeEnum(1, f)
  }
  f = message.getStatusCode()
  if (f !== 0) {
    writer.writeInt32(2, f)
  }
  f = message.getMessage()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
}

/**
 * @enum {number}
 */
proto.advai_event.atome_id.StatusMessage.Status = {
  STATUSNULL: 0,
  FAILURE: 1,
  SUCCESS: 2,
}

/**
 * optional Status status = 1;
 * @return {!proto.advai_event.atome_id.StatusMessage.Status}
 */
proto.advai_event.atome_id.StatusMessage.prototype.getStatus = function () {
  return /** @type {!proto.advai_event.atome_id.StatusMessage.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {!proto.advai_event.atome_id.StatusMessage.Status} value
 * @return {!proto.advai_event.atome_id.StatusMessage} returns this
 */
proto.advai_event.atome_id.StatusMessage.prototype.setStatus = function (value) {
  return jspb.Message.setProto3EnumField(this, 1, value)
}

/**
 * optional int32 status_code = 2;
 * @return {number}
 */
proto.advai_event.atome_id.StatusMessage.prototype.getStatusCode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/**
 * @param {number} value
 * @return {!proto.advai_event.atome_id.StatusMessage} returns this
 */
proto.advai_event.atome_id.StatusMessage.prototype.setStatusCode = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value)
}

/**
 * optional string message = 3;
 * @return {string}
 */
proto.advai_event.atome_id.StatusMessage.prototype.getMessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.advai_event.atome_id.StatusMessage} returns this
 */
proto.advai_event.atome_id.StatusMessage.prototype.setMessage = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.advai_event.atome_id.Page.prototype.toObject = function (opt_includeInstance) {
    return proto.advai_event.atome_id.Page.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.advai_event.atome_id.Page} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.advai_event.atome_id.Page.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        pageName: jspb.Message.getFieldWithDefault(msg, 1, 0),
        paramsMap: (f = msg.getParamsMap()) ? f.toObject(includeInstance, undefined) : [],
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.advai_event.atome_id.Page}
 */
proto.advai_event.atome_id.Page.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.advai_event.atome_id.Page()
  return proto.advai_event.atome_id.Page.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.advai_event.atome_id.Page} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.advai_event.atome_id.Page}
 */
proto.advai_event.atome_id.Page.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {!proto.advai_event.atome_id.PageName} */ (reader.readEnum())
        msg.setPageName(value)
        break
      case 2:
        var value = msg.getParamsMap()
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(
            message,
            reader,
            jspb.BinaryReader.prototype.readString,
            jspb.BinaryReader.prototype.readString,
            null,
            '',
            '',
          )
        })
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.advai_event.atome_id.Page.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.advai_event.atome_id.Page.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.advai_event.atome_id.Page} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.advai_event.atome_id.Page.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getPageName()
  if (f !== 0.0) {
    writer.writeEnum(1, f)
  }
  f = message.getParamsMap(true)
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString)
  }
}

/**
 * optional PageName page_name = 1;
 * @return {!proto.advai_event.atome_id.PageName}
 */
proto.advai_event.atome_id.Page.prototype.getPageName = function () {
  return /** @type {!proto.advai_event.atome_id.PageName} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {!proto.advai_event.atome_id.PageName} value
 * @return {!proto.advai_event.atome_id.Page} returns this
 */
proto.advai_event.atome_id.Page.prototype.setPageName = function (value) {
  return jspb.Message.setProto3EnumField(this, 1, value)
}

/**
 * map<string, string> params = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.advai_event.atome_id.Page.prototype.getParamsMap = function (opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (jspb.Message.getMapField(this, 2, opt_noLazyCreate, null))
}

/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.advai_event.atome_id.Page} returns this
 */
proto.advai_event.atome_id.Page.prototype.clearParamsMap = function () {
  this.getParamsMap().clear()
  return this
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.advai_event.atome_id.Event.prototype.toObject = function (opt_includeInstance) {
    return proto.advai_event.atome_id.Event.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.advai_event.atome_id.Event} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.advai_event.atome_id.Event.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        action: jspb.Message.getFieldWithDefault(msg, 1, 0),
        timestamp: jspb.Message.getFieldWithDefault(msg, 2, 0),
        location: (f = msg.getLocation()) && proto.advai_event.atome_id.Page.toObject(includeInstance, f),
        target: (f = msg.getTarget()) && proto.advai_event.atome_id.Page.toObject(includeInstance, f),
        status: (f = msg.getStatus()) && proto.advai_event.atome_id.StatusMessage.toObject(includeInstance, f),
        extraMap: (f = msg.getExtraMap()) ? f.toObject(includeInstance, undefined) : [],
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.advai_event.atome_id.Event}
 */
proto.advai_event.atome_id.Event.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.advai_event.atome_id.Event()
  return proto.advai_event.atome_id.Event.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.advai_event.atome_id.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.advai_event.atome_id.Event}
 */
proto.advai_event.atome_id.Event.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {!proto.advai_event.atome_id.Action} */ (reader.readEnum())
        msg.setAction(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setTimestamp(value)
        break
      case 3:
        var value = new proto.advai_event.atome_id.Page()
        reader.readMessage(value, proto.advai_event.atome_id.Page.deserializeBinaryFromReader)
        msg.setLocation(value)
        break
      case 4:
        var value = new proto.advai_event.atome_id.Page()
        reader.readMessage(value, proto.advai_event.atome_id.Page.deserializeBinaryFromReader)
        msg.setTarget(value)
        break
      case 6:
        var value = new proto.advai_event.atome_id.StatusMessage()
        reader.readMessage(value, proto.advai_event.atome_id.StatusMessage.deserializeBinaryFromReader)
        msg.setStatus(value)
        break
      case 100:
        var value = msg.getExtraMap()
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(
            message,
            reader,
            jspb.BinaryReader.prototype.readString,
            jspb.BinaryReader.prototype.readString,
            null,
            '',
            '',
          )
        })
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.advai_event.atome_id.Event.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.advai_event.atome_id.Event.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.advai_event.atome_id.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.advai_event.atome_id.Event.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getAction()
  if (f !== 0.0) {
    writer.writeEnum(1, f)
  }
  f = message.getTimestamp()
  if (f !== 0) {
    writer.writeInt64(2, f)
  }
  f = message.getLocation()
  if (f != null) {
    writer.writeMessage(3, f, proto.advai_event.atome_id.Page.serializeBinaryToWriter)
  }
  f = message.getTarget()
  if (f != null) {
    writer.writeMessage(4, f, proto.advai_event.atome_id.Page.serializeBinaryToWriter)
  }
  f = message.getStatus()
  if (f != null) {
    writer.writeMessage(6, f, proto.advai_event.atome_id.StatusMessage.serializeBinaryToWriter)
  }
  f = message.getExtraMap(true)
  if (f && f.getLength() > 0) {
    f.serializeBinary(100, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString)
  }
}

/**
 * optional Action action = 1;
 * @return {!proto.advai_event.atome_id.Action}
 */
proto.advai_event.atome_id.Event.prototype.getAction = function () {
  return /** @type {!proto.advai_event.atome_id.Action} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {!proto.advai_event.atome_id.Action} value
 * @return {!proto.advai_event.atome_id.Event} returns this
 */
proto.advai_event.atome_id.Event.prototype.setAction = function (value) {
  return jspb.Message.setProto3EnumField(this, 1, value)
}

/**
 * optional int64 timestamp = 2;
 * @return {number}
 */
proto.advai_event.atome_id.Event.prototype.getTimestamp = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/**
 * @param {number} value
 * @return {!proto.advai_event.atome_id.Event} returns this
 */
proto.advai_event.atome_id.Event.prototype.setTimestamp = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value)
}

/**
 * optional Page location = 3;
 * @return {?proto.advai_event.atome_id.Page}
 */
proto.advai_event.atome_id.Event.prototype.getLocation = function () {
  return /** @type{?proto.advai_event.atome_id.Page} */ (jspb.Message.getWrapperField(
    this,
    proto.advai_event.atome_id.Page,
    3,
  ))
}

/**
 * @param {?proto.advai_event.atome_id.Page|undefined} value
 * @return {!proto.advai_event.atome_id.Event} returns this
 */
proto.advai_event.atome_id.Event.prototype.setLocation = function (value) {
  return jspb.Message.setWrapperField(this, 3, value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.advai_event.atome_id.Event} returns this
 */
proto.advai_event.atome_id.Event.prototype.clearLocation = function () {
  return this.setLocation(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.advai_event.atome_id.Event.prototype.hasLocation = function () {
  return jspb.Message.getField(this, 3) != null
}

/**
 * optional Page target = 4;
 * @return {?proto.advai_event.atome_id.Page}
 */
proto.advai_event.atome_id.Event.prototype.getTarget = function () {
  return /** @type{?proto.advai_event.atome_id.Page} */ (jspb.Message.getWrapperField(
    this,
    proto.advai_event.atome_id.Page,
    4,
  ))
}

/**
 * @param {?proto.advai_event.atome_id.Page|undefined} value
 * @return {!proto.advai_event.atome_id.Event} returns this
 */
proto.advai_event.atome_id.Event.prototype.setTarget = function (value) {
  return jspb.Message.setWrapperField(this, 4, value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.advai_event.atome_id.Event} returns this
 */
proto.advai_event.atome_id.Event.prototype.clearTarget = function () {
  return this.setTarget(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.advai_event.atome_id.Event.prototype.hasTarget = function () {
  return jspb.Message.getField(this, 4) != null
}

/**
 * optional StatusMessage status = 6;
 * @return {?proto.advai_event.atome_id.StatusMessage}
 */
proto.advai_event.atome_id.Event.prototype.getStatus = function () {
  return /** @type{?proto.advai_event.atome_id.StatusMessage} */ (jspb.Message.getWrapperField(
    this,
    proto.advai_event.atome_id.StatusMessage,
    6,
  ))
}

/**
 * @param {?proto.advai_event.atome_id.StatusMessage|undefined} value
 * @return {!proto.advai_event.atome_id.Event} returns this
 */
proto.advai_event.atome_id.Event.prototype.setStatus = function (value) {
  return jspb.Message.setWrapperField(this, 6, value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.advai_event.atome_id.Event} returns this
 */
proto.advai_event.atome_id.Event.prototype.clearStatus = function () {
  return this.setStatus(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.advai_event.atome_id.Event.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 6) != null
}

/**
 * map<string, string> extra = 100;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.advai_event.atome_id.Event.prototype.getExtraMap = function (opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (jspb.Message.getMapField(this, 100, opt_noLazyCreate, null))
}

/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.advai_event.atome_id.Event} returns this
 */
proto.advai_event.atome_id.Event.prototype.clearExtraMap = function () {
  this.getExtraMap().clear()
  return this
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.advai_event.atome_id.ReferrerDeviceInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.advai_event.atome_id.ReferrerDeviceInfo.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.advai_event.atome_id.ReferrerDeviceInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.advai_event.atome_id.ReferrerDeviceInfo.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        extraMap: (f = msg.getExtraMap()) ? f.toObject(includeInstance, undefined) : [],
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.advai_event.atome_id.ReferrerDeviceInfo}
 */
proto.advai_event.atome_id.ReferrerDeviceInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.advai_event.atome_id.ReferrerDeviceInfo()
  return proto.advai_event.atome_id.ReferrerDeviceInfo.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.advai_event.atome_id.ReferrerDeviceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.advai_event.atome_id.ReferrerDeviceInfo}
 */
proto.advai_event.atome_id.ReferrerDeviceInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = msg.getExtraMap()
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(
            message,
            reader,
            jspb.BinaryReader.prototype.readString,
            jspb.BinaryReader.prototype.readString,
            null,
            '',
            '',
          )
        })
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.advai_event.atome_id.ReferrerDeviceInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.advai_event.atome_id.ReferrerDeviceInfo.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.advai_event.atome_id.ReferrerDeviceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.advai_event.atome_id.ReferrerDeviceInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getExtraMap(true)
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString)
  }
}

/**
 * map<string, string> extra = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.advai_event.atome_id.ReferrerDeviceInfo.prototype.getExtraMap = function (opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (jspb.Message.getMapField(this, 1, opt_noLazyCreate, null))
}

/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.advai_event.atome_id.ReferrerDeviceInfo} returns this
 */
proto.advai_event.atome_id.ReferrerDeviceInfo.prototype.clearExtraMap = function () {
  this.getExtraMap().clear()
  return this
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.advai_event.atome_id.DeviceInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.advai_event.atome_id.DeviceInfo.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.advai_event.atome_id.DeviceInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.advai_event.atome_id.DeviceInfo.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        advertisingId: jspb.Message.getFieldWithDefault(msg, 1, ''),
        userId: jspb.Message.getFieldWithDefault(msg, 2, ''),
        userType: jspb.Message.getFieldWithDefault(msg, 3, 0),
        deviceType: jspb.Message.getFieldWithDefault(msg, 4, 0),
        uuid: jspb.Message.getFieldWithDefault(msg, 5, ''),
        appVersion: jspb.Message.getFieldWithDefault(msg, 6, ''),
        appVersionCode: jspb.Message.getFieldWithDefault(msg, 7, 0),
        source: jspb.Message.getFieldWithDefault(msg, 8, ''),
        osVersion: jspb.Message.getFieldWithDefault(msg, 9, ''),
        model: jspb.Message.getFieldWithDefault(msg, 10, ''),
        referrerInfo:
          (f = msg.getReferrerInfo()) && proto.advai_event.atome_id.ReferrerDeviceInfo.toObject(includeInstance, f),
        osType: jspb.Message.getFieldWithDefault(msg, 12, 0),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.advai_event.atome_id.DeviceInfo}
 */
proto.advai_event.atome_id.DeviceInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.advai_event.atome_id.DeviceInfo()
  return proto.advai_event.atome_id.DeviceInfo.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.advai_event.atome_id.DeviceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.advai_event.atome_id.DeviceInfo}
 */
proto.advai_event.atome_id.DeviceInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString())
        msg.setAdvertisingId(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setUserId(value)
        break
      case 3:
        var value = /** @type {!proto.advai_event.atome_id.DeviceInfo.UserType} */ (reader.readEnum())
        msg.setUserType(value)
        break
      case 4:
        var value = /** @type {!proto.advai_event.atome_id.DeviceInfo.DeviceType} */ (reader.readEnum())
        msg.setDeviceType(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setUuid(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setAppVersion(value)
        break
      case 7:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setAppVersionCode(value)
        break
      case 8:
        var value = /** @type {string} */ (reader.readString())
        msg.setSource(value)
        break
      case 9:
        var value = /** @type {string} */ (reader.readString())
        msg.setOsVersion(value)
        break
      case 10:
        var value = /** @type {string} */ (reader.readString())
        msg.setModel(value)
        break
      case 11:
        var value = new proto.advai_event.atome_id.ReferrerDeviceInfo()
        reader.readMessage(value, proto.advai_event.atome_id.ReferrerDeviceInfo.deserializeBinaryFromReader)
        msg.setReferrerInfo(value)
        break
      case 12:
        var value = /** @type {!proto.advai_event.atome_id.DeviceInfo.OSType} */ (reader.readEnum())
        msg.setOsType(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.advai_event.atome_id.DeviceInfo.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.advai_event.atome_id.DeviceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.advai_event.atome_id.DeviceInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getAdvertisingId()
  if (f.length > 0) {
    writer.writeString(1, f)
  }
  f = message.getUserId()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getUserType()
  if (f !== 0.0) {
    writer.writeEnum(3, f)
  }
  f = message.getDeviceType()
  if (f !== 0.0) {
    writer.writeEnum(4, f)
  }
  f = message.getUuid()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getAppVersion()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getAppVersionCode()
  if (f !== 0) {
    writer.writeInt32(7, f)
  }
  f = message.getSource()
  if (f.length > 0) {
    writer.writeString(8, f)
  }
  f = message.getOsVersion()
  if (f.length > 0) {
    writer.writeString(9, f)
  }
  f = message.getModel()
  if (f.length > 0) {
    writer.writeString(10, f)
  }
  f = message.getReferrerInfo()
  if (f != null) {
    writer.writeMessage(11, f, proto.advai_event.atome_id.ReferrerDeviceInfo.serializeBinaryToWriter)
  }
  f = message.getOsType()
  if (f !== 0.0) {
    writer.writeEnum(12, f)
  }
}

/**
 * @enum {number}
 */
proto.advai_event.atome_id.DeviceInfo.UserType = {
  USERTYPENULL: 0,
  NEW: 1,
  OKP: 2,
  NKP: 3,
  BOTH: 4,
  EFFORTLESS_LOAN: 5,
}

/**
 * @enum {number}
 */
proto.advai_event.atome_id.DeviceInfo.DeviceType = {
  APP: 0,
  H5: 1,
  OFFICIALWEB: 2,
}

/**
 * @enum {number}
 */
proto.advai_event.atome_id.DeviceInfo.OSType = {
  NULL: 0,
  ANDROID: 1,
  IOS: 2,
  WEB: 3,
  OTHERS: 4,
}

/**
 * optional string advertising_id = 1;
 * @return {string}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getAdvertisingId = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''))
}

/**
 * @param {string} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setAdvertisingId = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value)
}

/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getUserId = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setUserId = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional UserType user_type = 3;
 * @return {!proto.advai_event.atome_id.DeviceInfo.UserType}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getUserType = function () {
  return /** @type {!proto.advai_event.atome_id.DeviceInfo.UserType} */ (jspb.Message.getFieldWithDefault(this, 3, 0))
}

/**
 * @param {!proto.advai_event.atome_id.DeviceInfo.UserType} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setUserType = function (value) {
  return jspb.Message.setProto3EnumField(this, 3, value)
}

/**
 * optional DeviceType device_type = 4;
 * @return {!proto.advai_event.atome_id.DeviceInfo.DeviceType}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getDeviceType = function () {
  return /** @type {!proto.advai_event.atome_id.DeviceInfo.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 4, 0))
}

/**
 * @param {!proto.advai_event.atome_id.DeviceInfo.DeviceType} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setDeviceType = function (value) {
  return jspb.Message.setProto3EnumField(this, 4, value)
}

/**
 * optional string uuid = 5;
 * @return {string}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getUuid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setUuid = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional string app_version = 6;
 * @return {string}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getAppVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setAppVersion = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * optional int32 app_version_code = 7;
 * @return {number}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getAppVersionCode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0))
}

/**
 * @param {number} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setAppVersionCode = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value)
}

/**
 * optional string source = 8;
 * @return {string}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getSource = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''))
}

/**
 * @param {string} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setSource = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value)
}

/**
 * optional string os_version = 9;
 * @return {string}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getOsVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''))
}

/**
 * @param {string} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setOsVersion = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value)
}

/**
 * optional string model = 10;
 * @return {string}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getModel = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''))
}

/**
 * @param {string} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setModel = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value)
}

/**
 * optional ReferrerDeviceInfo referrer_info = 11;
 * @return {?proto.advai_event.atome_id.ReferrerDeviceInfo}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getReferrerInfo = function () {
  return /** @type{?proto.advai_event.atome_id.ReferrerDeviceInfo} */ (jspb.Message.getWrapperField(
    this,
    proto.advai_event.atome_id.ReferrerDeviceInfo,
    11,
  ))
}

/**
 * @param {?proto.advai_event.atome_id.ReferrerDeviceInfo|undefined} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setReferrerInfo = function (value) {
  return jspb.Message.setWrapperField(this, 11, value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.clearReferrerInfo = function () {
  return this.setReferrerInfo(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.hasReferrerInfo = function () {
  return jspb.Message.getField(this, 11) != null
}

/**
 * optional OSType os_type = 12;
 * @return {!proto.advai_event.atome_id.DeviceInfo.OSType}
 */
proto.advai_event.atome_id.DeviceInfo.prototype.getOsType = function () {
  return /** @type {!proto.advai_event.atome_id.DeviceInfo.OSType} */ (jspb.Message.getFieldWithDefault(this, 12, 0))
}

/**
 * @param {!proto.advai_event.atome_id.DeviceInfo.OSType} value
 * @return {!proto.advai_event.atome_id.DeviceInfo} returns this
 */
proto.advai_event.atome_id.DeviceInfo.prototype.setOsType = function (value) {
  return jspb.Message.setProto3EnumField(this, 12, value)
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.advai_event.atome_id.EventPackage.repeatedFields_ = [4]

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.advai_event.atome_id.EventPackage.prototype.toObject = function (opt_includeInstance) {
    return proto.advai_event.atome_id.EventPackage.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.advai_event.atome_id.EventPackage} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.advai_event.atome_id.EventPackage.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0),
        device: (f = msg.getDevice()) && proto.advai_event.atome_id.DeviceInfo.toObject(includeInstance, f),
        eventsList: jspb.Message.toObjectList(
          msg.getEventsList(),
          proto.advai_event.atome_id.Event.toObject,
          includeInstance,
        ),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.advai_event.atome_id.EventPackage}
 */
proto.advai_event.atome_id.EventPackage.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.advai_event.atome_id.EventPackage()
  return proto.advai_event.atome_id.EventPackage.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.advai_event.atome_id.EventPackage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.advai_event.atome_id.EventPackage}
 */
proto.advai_event.atome_id.EventPackage.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setTimestamp(value)
        break
      case 3:
        var value = new proto.advai_event.atome_id.DeviceInfo()
        reader.readMessage(value, proto.advai_event.atome_id.DeviceInfo.deserializeBinaryFromReader)
        msg.setDevice(value)
        break
      case 4:
        var value = new proto.advai_event.atome_id.Event()
        reader.readMessage(value, proto.advai_event.atome_id.Event.deserializeBinaryFromReader)
        msg.addEvents(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.advai_event.atome_id.EventPackage.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.advai_event.atome_id.EventPackage.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.advai_event.atome_id.EventPackage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.advai_event.atome_id.EventPackage.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getTimestamp()
  if (f !== 0) {
    writer.writeInt64(1, f)
  }
  f = message.getDevice()
  if (f != null) {
    writer.writeMessage(3, f, proto.advai_event.atome_id.DeviceInfo.serializeBinaryToWriter)
  }
  f = message.getEventsList()
  if (f.length > 0) {
    writer.writeRepeatedMessage(4, f, proto.advai_event.atome_id.Event.serializeBinaryToWriter)
  }
}

/**
 * optional int64 timestamp = 1;
 * @return {number}
 */
proto.advai_event.atome_id.EventPackage.prototype.getTimestamp = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {number} value
 * @return {!proto.advai_event.atome_id.EventPackage} returns this
 */
proto.advai_event.atome_id.EventPackage.prototype.setTimestamp = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value)
}

/**
 * optional DeviceInfo device = 3;
 * @return {?proto.advai_event.atome_id.DeviceInfo}
 */
proto.advai_event.atome_id.EventPackage.prototype.getDevice = function () {
  return /** @type{?proto.advai_event.atome_id.DeviceInfo} */ (jspb.Message.getWrapperField(
    this,
    proto.advai_event.atome_id.DeviceInfo,
    3,
  ))
}

/**
 * @param {?proto.advai_event.atome_id.DeviceInfo|undefined} value
 * @return {!proto.advai_event.atome_id.EventPackage} returns this
 */
proto.advai_event.atome_id.EventPackage.prototype.setDevice = function (value) {
  return jspb.Message.setWrapperField(this, 3, value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.advai_event.atome_id.EventPackage} returns this
 */
proto.advai_event.atome_id.EventPackage.prototype.clearDevice = function () {
  return this.setDevice(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.advai_event.atome_id.EventPackage.prototype.hasDevice = function () {
  return jspb.Message.getField(this, 3) != null
}

/**
 * repeated Event events = 4;
 * @return {!Array<!proto.advai_event.atome_id.Event>}
 */
proto.advai_event.atome_id.EventPackage.prototype.getEventsList = function () {
  return /** @type{!Array<!proto.advai_event.atome_id.Event>} */ (jspb.Message.getRepeatedWrapperField(
    this,
    proto.advai_event.atome_id.Event,
    4,
  ))
}

/**
 * @param {!Array<!proto.advai_event.atome_id.Event>} value
 * @return {!proto.advai_event.atome_id.EventPackage} returns this
 */
proto.advai_event.atome_id.EventPackage.prototype.setEventsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value)
}

/**
 * @param {!proto.advai_event.atome_id.Event=} opt_value
 * @param {number=} opt_index
 * @return {!proto.advai_event.atome_id.Event}
 */
proto.advai_event.atome_id.EventPackage.prototype.addEvents = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.advai_event.atome_id.Event, opt_index)
}

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.advai_event.atome_id.EventPackage} returns this
 */
proto.advai_event.atome_id.EventPackage.prototype.clearEventsList = function () {
  return this.setEventsList([])
}

goog.object.extend(exports, proto.advai_event.atome_id)
